import { server } from "@/api";

export const stats = async () => {
    return await server().get('api/dashboard/stats');
}

export default { stats };
